import {Component} from '@angular/core';
import {SplashScreen} from '@ionic-native/splash-screen';
import {StatusBar} from '@ionic-native/status-bar';
import {TranslateService} from '@ngx-translate/core';
import {Config, Platform} from 'ionic-angular';
import {JPush} from "@jiguang-ionic/jpush";
import {FirstRunPage} from '../pages/pages';
import {ImageLoaderConfig} from "ionic-image-loader";
import {UserService} from "../providers/data-service/user-service";


declare let window: any;

@Component({
  template: '<ion-nav #content [root]="rootPage"></ion-nav>'
})
export class MyApp {
  rootPage = FirstRunPage;

  constructor(private translate: TranslateService,
              private platform: Platform,
              private config: Config,
              public jpush: JPush,
              private statusBar: StatusBar,
              private splashScreen: SplashScreen,
              public user: UserService,
              private imageLoaderConfig: ImageLoaderConfig) {

    // set the maximum concurrent connections
    this.imageLoaderConfig.setConcurrency(5);
    this.imageLoaderConfig.enableFallbackAsPlaceholder(true);
    this.imageLoaderConfig.setFallbackUrl('assets/img/preload.jpg');

    this.initTranslate();

    this.platform.ready().then(() => {

      if (this.platform.is('cordova')) { //
        this.statusBar.styleDefault();
        this.splashScreen.hide();

        this.jpush.init();
        // if(window.navigator.splashscreen)
        // {
        //     window.navigator.splashscreen.hide();
        // }
      }

    });

  }

  initTranslate() {
    // Set the default language for translation strings, and the current language.
    this.translate.setDefaultLang('zh');

    if (this.translate.getBrowserLang() !== undefined) {
      this.translate.use(this.translate.getBrowserLang());
    } else {
      this.translate.use('zh'); // Set your language here
    }

    this.translate.get(['BACK_BUTTON_TEXT']).subscribe(values => {
      this.config.set('ios', 'backButtonText', values.BACK_BUTTON_TEXT);
    });
  }




}



// WEBPACK FOOTER //
// ./src/app/app.component.ts